<!-- Loading -->
<ng-container *ngIf="(assignmentParticipantStateService.assignmentParticipantsSubject| async) == null">
    <div class="text-center">
        <span><i class="fa-solid fa-spinner fa-spin"></i></span>
    </div>
</ng-container>

<ng-container *ngIf="(assignmentParticipantStateService.assignmentParticipantsSubject | async) as participants">
    <div class="d-flex flex-column gap-3" *ngIf="participants.length">
        <app-assignment-participants-list></app-assignment-participants-list>

        <ng-container *ngIf="(assignmentDetailsStateService.assignmentDetails | async) as details">
            <ng-container *ngIf="details.hasDownloadableRegistrationDetails">
                <app-assignment-participant-registration-details-export
                    [assignmentId]="assignmentId"></app-assignment-participant-registration-details-export>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="(assignmentDetailsStateService.assignmentDetails | async) as details">
            <ng-container *ngIf="isAttendanceCheckAllowed">
                <app-assignment-attendance [assignmentId]="assignmentId"
                    [deadline]="getDeadline(details.isLesson, details.to)">
                </app-assignment-attendance>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="isSkillAllocationAllowed">
            <app-assignment-sportskills [assignmentId]="assignmentId"></app-assignment-sportskills>
        </ng-container>
        <app-assignment-contact-participants [assignmentId]="assignmentId"></app-assignment-contact-participants>
    </div>
    <div class="alert alert-secondary" *ngIf="!participants.length">
        {{'assignments.participants.noParticipants' | transloco}}
    </div>
</ng-container>